<template>
  <div class="class-charts">
    <!-- 分类得分情况 -->
    <div class="canvas-box" ref="heartBar" style="height:110px; margin-top: -40px;" v-if="this.model.length + 1 != 2"></div>
    <div class="canvas-box" ref="heartBar" style="height:90px; margin-top: -50px;" v-if="this.model.length + 1 == 2"></div>
  </div>
</template>
<script>
export default {
  props: ["model", "name1", "score1"],
  data() {
    return {
      name: [],
      score: [],
      score2: [],
      size: 14,
    };
  },
  mounted() {
    this.renderMap();
  },
  watch: {},
  methods: {
    renderMap() {
      this.name.push(this.name1);
      this.score2.push(this.score1);
      this.model.map((item) => {
        this.name.push(item.name);
        this.score.push(item.score);
      });
      let heartBar = (window.cc = this.$echarts.init(
        this.$refs["heartBar"],
        null,
        {
          renderer: "svg",
        }
      ));
      let option = {
        grid: {
          top: "0%",
          left: "2%",
          right: "11%",
          bottom: "2%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "category",
            data: this.name,
            inverse: true,
            axisLine: { show: false }, // 轴线
            axisTick: { show: false }, // 刻度
            splitLine: { show: false }, // 分隔线
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14,
                color: "black",
              },
              formatter: function (data1, data2) {
                if (data2 == 0) {
                  return "{b|" + data1 + "}";
                } else {
                  return data1;
                }
              },
              rich: {
                b: {
                  fontWeight: "bold",
                  fontSize: 15,
                },
                // a:{
                //     padding:[10,0,0,0]
                // }

              },
            },
            // axisLine: {

            //   lineStyle: {
            //     color: "#D1E0EF",
            //   },
            // },
          },
        ],
        xAxis: {
          max: 10,
          min: 0,
          position: "top",
          interval: 2,
          type: "value",
          axisLine: { show: false }, // 轴线
          axisTick: { show: false }, // 刻度
          splitLine: { show: false }, // 分隔线
          axisLabel: {
            margin: 23,
            textStyle: {
              fontSize: 18,
              fontWeight: "bold",
              color: "#29BDB9",
            },
          },
        },
        series: [
          {
            // barGap:'20%',/*多个并排柱子设置柱子之间的间距*/
            type: "bar",
            barWidth: 40,
          
            data: this.score2,
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  let colors = ["#68C6EF"];
                  return colors[params.dataIndex];
                },
              },
            },
          },
          {
            type: "bar",
            barGap:'23%',/*多个并排柱子设置柱子之间的间距*/
            barWidth: this.size,
            data: this.score,
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  let colors = ["#A5DEF7", "#A5DEF7"];
                  return colors[params.dataIndex];
                },
              },
            },
          },
        ],
      };
      heartBar.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.class-charts {
  position: relative;
  .canvas-box {
    width: 308px;
    // height: 110px;
    margin-left: 17px;
   
    // margin: 10px auto 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/all/heartBarAll/heartBar.vue